import './sticky-header.less';
import { scrollMonitorServiceModule } from '../../services/scroll-monitor-service/scroll-monitor-service';

export const stickyHeaderComponentModule = angular
  .module('Q.components.sticky-header', [scrollMonitorServiceModule])

  .directive(
    'stickyHeader',
    function (scrollMonitorService, $timeout, $window) {
      return {
        restrict: 'A',
        link: function (scope, $elem, attr) {
          if (
            attr.stickyHeaderNonMobile !== undefined &&
            angular.element($window).offsetWidth() < 768
          ) {
            return;
          }
          $timeout(() => {
            // create clone of the element to act as a placeholder when we scroll off-screen
            const elem = $elem[0];
            const $placeholder = $elem.clone();
            const placeholder = $placeholder[0];
            $placeholder.addClass('sticky-header-placeholder-inactive');
            $elem.addClass('sticky-header');
            $elem.after($placeholder);

            let viewport = attr.stickyHeader || $elem.scrollableParent();

            let lastTop = null;
            let lastLeft = null;
            let lastActive = false;

            let isTable = elem.nodeName === 'THEAD' || elem.nodeName === 'TR';

            const scrollWatcher = scrollMonitorService.addListener(
              viewport,
              (event, data) => {
                const nonScrollEvent = event && event.type !== 'scroll';
                let elTop = data.elementTop;
                if (lastActive) {
                  // the element top won't be useful if we were already active
                  if (nonScrollEvent) {
                    // if we've had a DOM change, lastTop may no longer be correct
                    elTop =
                      $placeholder.offsetTop() -
                      $placeholder.scrollableParent().offsetTop();
                  } else {
                    // otherwise, if just scrolling, we can safely use the last known top
                    elTop = lastTop;
                  }
                }
                const elLeft = lastActive ? lastLeft : $elem.offsetLeft();
                const active = data.viewportScrollTop >= elTop;
                const shouldUpdate = lastActive !== active;

                // toggle classes if we're changing state
                if (shouldUpdate) {
                  $elem.toggleClass('sticky-header-active', active);
                  $placeholder.toggleClass(
                    'sticky-header-placeholder-inactive',
                    !active,
                  );
                  $placeholder.toggleClass(
                    'sticky-header-placeholder-active',
                    active,
                  );

                  $elem.css('top', active ? data.viewportTop + 'px' : null);
                  $elem.css('left', active ? elLeft + 'px' : null);
                  $elem.css('margin-top', active ? '0' : null);
                }
                if (shouldUpdate || active) {
                  if (attr.stickyHeaderSetWidth !== 'false') {
                    $elem.css(
                      'width',
                      active ? placeholder.offsetWidth + 'px' : null,
                    );
                  }
                  if (attr.stickyHeaderSetHeight !== 'false') {
                    $elem.css(
                      'height',
                      active ? placeholder.offsetHeight + 'px' : null,
                    );
                  }
                }

                // update table cells everytime if active, or if changing states
                if (isTable && (shouldUpdate || active)) {
                  const origCells = elem.querySelectorAll('td,th');
                  const phCells = placeholder.querySelectorAll('td,th');
                  angular.forEach(phCells, function (cell, idx) {
                    const width = active ? cell.offsetWidth + 'px' : null;
                    const height = active ? cell.offsetHeight + 'px' : null;
                    angular.element(origCells[idx]).css('min-width', width);
                    angular.element(origCells[idx]).css('min-height', height);
                  });
                }

                lastActive = active;
                lastTop = elTop;
                lastLeft = elLeft;
              },
              $elem,
            );

            scope.$on('$destroy', () => scrollWatcher.destroy());
          }, 250);
        },
      };
    },
  );
